import { useLocation } from 'react-router-dom';
import qs from 'qs';

export default () =>
  qs.parse(useLocation().search, { ignoreQueryPrefix: true }) as { [key: string]: string };
